import React from 'react';

// App-like bottom tab bar for the member area. Fixed to the viewport bottom,
// full-width, safe-area aware (.safe-bottom from index.css clears the iPhone home
// indicator). Active tab in gold (primary-500), inactive muted. Touch targets are
// >= 56px tall. Inline SVGs (no icon dependency added).

const Icon = ({ children }) => (
  <svg className="w-6 h-6" fill="none" stroke="currentColor" strokeWidth="2"
    strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24" aria-hidden="true">
    {children}
  </svg>
);

const HomeIcon = () => <Icon><path d="M3 11.5 12 4l9 7.5" /><path d="M5 10v9a1 1 0 0 0 1 1h3v-5h6v5h3a1 1 0 0 0 1-1v-9" /></Icon>;
const PaymentsIcon = () => <Icon><rect x="2.5" y="5.5" width="19" height="13" rx="2" /><path d="M2.5 9.5h19" /></Icon>;
const ScheduleIcon = () => <Icon><rect x="3.5" y="4.5" width="17" height="16" rx="2" /><path d="M3.5 9.5h17M8 3v3M16 3v3" /></Icon>;
const AccountIcon = () => <Icon><circle cx="12" cy="8" r="3.5" /><path d="M5 20a7 7 0 0 1 14 0" /></Icon>;

export const MEMBER_TABS = [
  { key: 'home', label: 'Home', Icon: HomeIcon },
  { key: 'payments', label: 'Payments', Icon: PaymentsIcon },
  { key: 'schedule', label: 'Schedule', Icon: ScheduleIcon },
  { key: 'account', label: 'Account', Icon: AccountIcon },
];

const BottomNav = ({ active, onChange }) => (
  <nav className="fixed bottom-0 inset-x-0 z-40 bg-neutral-100 border-t border-neutral-200 safe-bottom">
    <div className="max-w-6xl mx-auto flex">
      {MEMBER_TABS.map(({ key, label, Icon: TabIcon }) => {
        const isActive = active === key;
        return (
          <button
            key={key}
            type="button"
            onClick={() => onChange(key)}
            aria-current={isActive ? 'page' : undefined}
            className={`flex-1 flex flex-col items-center justify-center gap-1 py-2 min-h-[56px] transition-colors ${
              isActive ? 'text-primary-500' : 'text-neutral-500 hover:text-neutral-700'
            }`}
          >
            <TabIcon />
            <span className="text-xs font-medium">{label}</span>
          </button>
        );
      })}
    </div>
  </nav>
);

export default BottomNav;
